import { createFileRoute, redirect } from "@tanstack/react-router";

import { bffDocumentRedirect } from "@/lib/api/auth-redirect";

/**
 * Ancienne URL /auth/logout (sans préfixe /api) : renvoie vers le BFF derrière nginx.
 */
export const Route = createFileRoute("/_public/auth/logout")({
  beforeLoad: () => {
    throw redirect(bffDocumentRedirect("/api/auth/logout"));
  },
});
